module.exports="#define GLSLIFY 1\nattribute vec2 position;\n  void main() {\n    gl_Position = vec4(position, 0, 1);\n  }";